import { Component } from '@theme/component';

class ProductQuizComponent extends Component {
  #currentScreen = 'intro';
  #answers = {};
  #history = [];
  #recommendationMap = null;

  connectedCallback() {
    super.connectedCallback();
    const mapEl = this.refs.recommendationMap;
    if (mapEl) {
      try {
        this.#recommendationMap = JSON.parse(mapEl.textContent);
      } catch (e) {
        console.error('Product quiz: failed to parse recommendation map', e);
      }
    }
  }

  start(event) {
    this.#history = ['intro'];
    this.#showScreen('q1');
    this.#updateProgress(1);
    this.#showBackButton(true);
  }

  answer(data, event) {
    const q = Number(data.q);
    const a = Number(data.a);
    this.#answers[q] = a;
    this.#history.push(`q${q}`);

    if (q === 1) {
      this.#showScreen('q2');
      this.#updateProgress(2);
    } else if (q === 2) {
      this.#showResults();
    }
  }

  goBack(event) {
    if (this.#history.length <= 1) return;
    this.#history.pop();
    const target = this.#history[this.#history.length - 1];

    if (target === 'intro') {
      this.#showScreen('intro');
      this.#showBackButton(false);
      this.refs.progress.hidden = true;
      this.#answers = {};
    } else {
      this.#showScreen(target);
      const step = target === 'q1' ? 1 : 2;
      this.#updateProgress(step);
    }
  }

  restart(event) {
    this.#answers = {};
    this.#history = [];
    this.#currentScreen = 'intro';
    this.#showScreen('intro');
    this.#showBackButton(false);
    this.refs.progress.hidden = true;
  }

  #showScreen(name) {
    const { screens, liveRegion } = this.refs;
    if (!screens) return;

    let targetScreen = null;
    for (const screen of screens) {
      const isTarget = screen.dataset.screen === name;
      screen.hidden = !isTarget;
      screen.classList.toggle('hb-quiz__screen--active', isTarget);
      if (isTarget) targetScreen = screen;
    }
    this.#currentScreen = name;

    // Move focus to the new screen's heading or first focusable element
    if (targetScreen) {
      const focusTarget = targetScreen.querySelector('h2, h3, button');
      if (focusTarget) {
        focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus();
      }
    }

    // Announce screen change to screen readers
    if (liveRegion) {
      const announcements = { intro: 'Quiz intro', q1: 'Question 1 of 2', q2: 'Question 2 of 2', results: 'Quiz results' };
      liveRegion.textContent = announcements[name] || '';
    }
  }

  #updateProgress(step) {
    const { progress, steps } = this.refs;
    if (!progress || !steps) return;

    progress.hidden = false;
    steps.forEach((el, i) => {
      const stepNum = i + 1;
      el.classList.toggle('hb-quiz__step--active', stepNum === step);
      el.classList.toggle('hb-quiz__step--complete', stepNum < step);
    });
  }

  #showBackButton(show) {
    const { backBtn } = this.refs;
    if (backBtn) backBtn.hidden = !show;
  }

  #showResults() {
    const key = `${this.#answers[1]}-${this.#answers[2]}`;
    const url = this.#recommendationMap?.[key] || '/collections/all';

    const { resultsContainer } = this.refs;
    if (resultsContainer) {
      resultsContainer.replaceChildren();
      const link = document.createElement('a');
      link.href = url;
      link.className = 'button hb-quiz__result-link';
      link.textContent = 'Shop Your Match';
      resultsContainer.appendChild(link);
    }

    this.#history.push('q2');
    this.#showScreen('results');
    this.#showBackButton(true);
    this.#updateProgress(2);
  }
}

if (!customElements.get('product-quiz-component')) {
  customElements.define('product-quiz-component', ProductQuizComponent);
}
